import React from 'react';
import PropTypes from 'prop-types';

import 'src/components/EmptyListing/ActionLink.scss';


const ActionLink = function ({ href, label, dataTest }) {
  return (
    <a data-test={ dataTest } href={ href } styleName="link">
      {label}
    </a>
  );
};

ActionLink.propTypes = {
  dataTest: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default ActionLink;
